import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=0945240a&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0945240a')) {
      api.createRecord('0945240a', component.options)
    } else {
      api.reload('0945240a', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=0945240a&", function () {
      api.rerender('0945240a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/Filters.vue"
export default component.exports